import { Content } from '../../types';

export const chiangRaiToGoldenTriangleContent: Content = {
  title: "טיול יום מצ'אנג ראי למשולש הזהב – חוויה היסטורית ותרבותית",
  imageUrl:
    '/images/thailand/chiang-rai-to-golden-triangle/chiang-rai-to-golden-triangle-wide.jpeg',
  introduction:
    "טיול יום צפונה מצ'אנג ראי לעבר משולש הזהב, הינו מסע מרתק אל נופי הנהרות, התרבות המקומית וההיסטוריה המורכבת של אזור זה. לאורך הדרך נפגוש את שבטי ההרים, נחווה נופי נהרות עוצמתיים, נלמד על עברו של האזור ונקנח במעיינות חמים מפנקים.",
  sections: [
    {
      title: 'תחנה ראשונה – ביקור בכפר שבט הקארן',
      type: 'text',
      content:
        'נתחיל את היום בביקור בכפר שבט הקארן (Baan Lorcha Village), הידוע כשבט ארוכות הצוואר. בני השבט משתייכים לקבוצת הקארן, שמקורה בבורמה (מיאנמר) והינם ידועים בשל המסורת הייחודית של ענידת טבעות מתכת על צווארי הנשים, מה שיוצר את המראה הייחודי שלהן. הביקור בכפר מעניק הצצה לחיי היומיום של בני השבט, לאומנות היד המסורתית שלהם ולמאבקם לשימור התרבות והמסורת המקומית.',
    },
    {
      title: 'תחנה שנייה – העיירה Mae Sai',
      type: 'text',
      content:
        'לאחר מכן נמשיך לעיירה Mae Sai, שהינה הנקודה הצפונית ביותר בתאילנד וגובלת עם מיאנמר. העיירה הינה מרכז סחר שוקק חיים, עם שווקי גבול ססגוניים שבהם ניתן למצוא תכשיטים, אבני חן, עבודות יד מקומיות ומוצרים מיובאים ממיאנמר. ניתן אף לעלות לנקודת תצפית הסמוכה למעבר הגבול כדי לקבל מבט פנורמי על האזור.',
    },
    {
      title: 'תחנה שלישית – משולש הזהב',
      type: 'text',
      content:
        'נמשיך בנסיעה לאורך כביש 1 ולאחר מכן נפנה מזרחה לכביש 1290 עד שנגיע למשולש הזהב – המקום שבו נפגשים גבולותיהן של תאילנד, לאוס ומיאנמר. בעבר היה האזור מוקד לגידול וסחר באופיום וכיום ניתן ללמוד על ההיסטוריה המורכבת שלו במוזיאון האופיום הקיים במקום. מומלץ מאוד לבקר במוזיאון זה, שמספק מבט מעמיק על השפעת הסחר באופיום על האזור כולו.<br />האטרקציה המרכזית במשולש הזהב הינה שייט בסירת לונגטייל על נהר המקונג, המאפשר הצצה לנופי האזור ואף הצצה קצרה לשטחה של לאוס. בנוסף, ניתן לבקר בפסל הבודהה המוזהב הגדול המשקיף על מפגש הנהרות ולהסתובב בשוק המקומי שבו ניתן למצוא מזכרות ייחודיות.',
    },
    {
      title: "תחנה רביעית – נסיעה לאורך נהר המקונג וביקור בצ'יאנג סאן",
      type: 'text',
      content:
        "נמשיך בנסיעה לאורך נהר המקונג בכביש 1290, אשר עובר דרך כפרים קטנים ונופים עוצרי נשימה. נגיע לעיירה העתיקה צ'יאנג סאן (Chiang Saen), שהייתה בעבר בירת ממלכת לאנה. ניתן לבקר במקדש Wat Phra That Chedi Luang, מקדש בודהיסטי עתיק עם שרידי מבנים היסטוריים ומגדל פעמונים גדול. המקום מעניק חוויה של רוגע ושלווה, לצד נופים יפים של הנהר.",
    },
    {
      title: 'תחנה חמישית – מעיינות חמים Pong Phrabat',
      type: 'text',
      content:
        "לקראת החזרה לצ'אנג ראי, נעצור להירגע במעיינות החמים Pong Phrabat Hot Springs. זהו מקום מושלם לסיום היום, עם בריכות מים תרמיים טבעיות בהן ניתן להשרות את הרגליים או לטבול בג'קוזי טבעי. המעיינות מוקפים בצמחייה ירוקה ומספקים חוויית רוגע מושלמת לאחר יום מלא בחוויות.<br />לאחר הבילוי במעיינות החמים, נחזור לצ'אנג ראי דרך הכבישים 1020, 1174 ו-1421, עם תחושת סיפוק מטיול עשיר בחוויות, היסטוריה ותרבות.",
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, זהו מסלול יום אידיאלי עבור מטיילים המחפשים לשלב בין טבע, היסטוריה, מפגשים תרבותיים ורוגע וכל זאת בנופים מהפנטים של צפון תאילנד.',
      type: 'text',
      isBold: true,
    },
  ],
};
